import { SnackbarState, SnackbarActionTypes, snackbarActionNames } from './types';

const initialState: SnackbarState = {
  notifications: [],
};

export const snackbarReducer = (
  state: SnackbarState = initialState,
  action: SnackbarActionTypes,
): SnackbarState => {
  switch (action.type) {
    case snackbarActionNames.ENQUEUE_SNACKBAR: {
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            key: action.type,
            ...action.notification,
          },
        ],
      };
    }
    case snackbarActionNames.CLOSE_SNACKBAR: {
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          action.notification.dismissAll || notification.key === action.notification.key
            ? { ...notification, dismissed: true }
            : { ...notification },
        ),
      };
    }
    case snackbarActionNames.REMOVE_SNACKBAR: {
      return {
        ...state,
        notifications: state.notifications.filter((notification) => notification.key),
      };
    }
    default:
      return state;
  }
};
